import i18next from 'i18next';

// O gatilho era um <i> escutando click: nao recebia foco, nao respondia a
// Enter/Espaco e o leitor de tela nao anunciava nada. Agora a view entrega um
// <button>, e aqui damos a ele nome acessivel e estado.
// O nome fica FIXO ("Mostrar senha") e quem muda e o aria-pressed — trocar o
// rotulo junto com o estado faz o leitor reanunciar o botao inteiro a cada
// clique, o que atrapalha mais do que ajuda.
export const tooglePassword = function (passwordInput, passwordIcon) {
	if (!passwordInput || !passwordIcon) return;

	// Nem toda tela chama inicializarInternacionalizacao() antes daqui; sem o guard,
	// o t() de uma instancia nao inicializada derrubaria o resto do init da pagina.
	const rotulo = i18next.isInitialized
		? i18next.t('MostrarSenha', { defaultValue: 'Mostrar senha' })
		: 'Mostrar senha';
	passwordIcon.setAttribute('aria-label', rotulo);
	passwordIcon.setAttribute('aria-pressed', 'false');

	passwordIcon.addEventListener("click", function () {
	  	// toggle the type attribute
	  	const type = passwordInput.getAttribute("type") === "password" ? "text" : "password";
	 	passwordInput.setAttribute("type", type);

	  	// toggle the icon
	  	this.classList.toggle("bi-eye");
	  	this.setAttribute('aria-pressed', type === 'text' ? 'true' : 'false');
	});
};
